import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
// import router from './router'
import VueSocketIO from 'vue-socket.io'
import SocketIO from 'socket.io-client'
import Clipboard from 'v-clipboard'

Vue.use(Clipboard)

Vue.config.productionTip = false

Vue.use(new VueSocketIO({
	debug: false,
	connection: SocketIO('https://mailinvicta.com')
}));

require('./eventbus');
require('./utils/filters');

new Vue({
	//   router,
	render: h => h(App)
}).$mount('#app')